module.exports = __webpack_public_path__ + "img/icone-hamburgueria.bfb55f7e.svg";